/* Manual chapter selection. All content remains readable without JavaScript. */
(() => {
  const init = (root) => {
    if (root.dataset.whyReady) return;
    const tabs = [...root.querySelectorAll('[data-why-tab]')];
    const panels = [...root.querySelectorAll('[data-why-panel]')];
    const list = root.querySelector('.wl-why__chapters');
    if (!tabs.length || tabs.length !== panels.length || !list) return;
    root.dataset.whyReady = 'true';
    const select = (index, focus = false) => {
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        panels[i].hidden = i !== index;
      });
      if (focus) tabs[index].focus();
    };
    list.setAttribute('role', 'tablist');
    tabs.forEach((tab, index) => {
      tab.setAttribute('role', 'tab');
      panels[index].setAttribute('role', 'tabpanel');
      panels[index].setAttribute('aria-labelledby', tab.id);
      panels[index].tabIndex = 0;
      tab.addEventListener('click', () => select(index));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        select(next, true);
      });
    });
    root.addEventListener('shopify:block:select', (event) => {
      const selectedPanel = event.target.closest('[data-why-panel]');
      const index = panels.indexOf(selectedPanel);
      if (index >= 0) select(index);
    });
    select(0);
    root.classList.add('is-enhanced');
    list.hidden = false;
  };
  const scan = (scope) => {
    if (scope.matches?.('[data-why-studio]')) init(scope);
    scope.querySelectorAll('[data-why-studio]').forEach(init);
  };
  scan(document);
  if (!window.woodlasWhyStudioLoaded) {
    window.woodlasWhyStudioLoaded = true;
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  }
})();
